/* eslint-disable no-use-before-define */
import { createApi } from '@reduxjs/toolkit/query/react';
import rcBaseQuery from './baseQuery';

export const registrationApi = createApi({
    reducerPath: 'registrationApi',
    baseQuery: rcBaseQuery,
    tagTypes: ['Registration', 'RegistrationList'],
    endpoints: (builder) => ({
        // Lightweight list of all registrations
        getRegistrations: builder.query({
            query: () => ({
                url: 'api/v2/registrations'
            }),
            providesTags: [{ type: 'RegistrationList', id: 'ALL' }]
        }),

        // Full single registration (with titles, notes, etc.)
        getRegistration: builder.query({
            query: ({ id }) => ({
                url: `api/v2/registrations/${id}`
            }),
            providesTags: (result, error, { id }) => [{ type: 'Registration', id }]
        }),

        // Create registration (V1 endpoint — no V2 create yet)
        createRegistration: builder.mutation({
            query: ({ data, regType }) => ({
                url: 'registration',
                method: 'POST',
                body: { data, regType }
            }),
            invalidatesTags: [{ type: 'RegistrationList', id: 'ALL' }]
        }),

        // Update registration (V1 endpoint)
        updateRegistration: builder.mutation({
            query: ({ id, data }) => ({
                url: `registration`,
                method: 'PUT',
                params: { id },
                body: data
            }),
            async onQueryStarted({ id }, { dispatch, queryFulfilled }) {
                try {
                    const { data: updatedReg } = await queryFulfilled;
                    // Patch single-registration cache
                    dispatch(
                        registrationApi.util.updateQueryData('getRegistration', { id }, (draft) => {
                            Object.assign(draft, updatedReg);
                        })
                    );
                    // Patch list cache
                    dispatch(
                        registrationApi.util.updateQueryData('getRegistrations', undefined, (draft) => {
                            if (Array.isArray(draft)) {
                                const idx = draft.findIndex((r) => r.id === id);
                                if (idx !== -1) Object.assign(draft[idx], updatedReg);
                            }
                        })
                    );
                } catch {
                    /* handled by RTK Query error state */
                }
            }
        })
    })
});

export const {
    useGetRegistrationsQuery,
    useGetRegistrationQuery,
    useCreateRegistrationMutation,
    useUpdateRegistrationMutation
} = registrationApi;
